import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-586b4e7e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row custom-mobile" }
const _hoisted_2 = { class: "col-xxl-3 col-sm-6 card-custom-mobile" }
const _hoisted_3 = { class: "card mb-none mb-sm-none mb-md-25 md-lg-25 md-xl-25 md-xxl-25 border-0 radius-7 bg-white stats-item" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing heigth-cards-recordings" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative text-primary rounded-1 text-center icon-custom-mobile" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-sterile-box" })
], -1))
const _hoisted_7 = { class: "title text-end custom-title-mobile" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-dark-emphasis mb-5 custom-size-title-mobile" }, " UPLOADS COM SUCESSO ", -1))
const _hoisted_9 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_10 = { class: "fw-black mb-0 me-10" }
const _hoisted_11 = { class: "mt-15 mt-md-25 mb-5 mb-md-8 d-flex justify-content-between align-items-center" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-secondary custom-size-title-mobile" }, " Porcentagem ", -1))
const _hoisted_13 = { class: "text-success fw-semibold" }
const _hoisted_14 = {
  class: "progress",
  role: "progressbar",
  "aria-valuenow": "38",
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_15 = { class: "col-xxl-3 col-sm-6 card-custom-mobile" }
const _hoisted_16 = { class: "card mb-none mb-sm-none mb-md-25 md-lg-25 md-xl-25 md-xxl-25 border-0 radius-7 bg-white stats-item" }
const _hoisted_17 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing heigth-cards-recordings" }
const _hoisted_18 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative text-success rounded-1 text-center icon-custom-mobile" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-sugar-cubes" })
], -1))
const _hoisted_20 = { class: "title text-end custom-title-mobile" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-dark-emphasis mb-5 custom-size-title-mobile" }, " UPLOADS COM ERRO ", -1))
const _hoisted_22 = { class: "d-flex align-items-center justify-content-end" }
const _hoisted_23 = { class: "fw-black mb-0 me-10" }
const _hoisted_24 = { class: "mt-15 mt-md-25 mb-5 mb-md-8 d-flex justify-content-between align-items-center" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-medium text-secondary custom-size-title-mobile" }, " Porcentagem ", -1))
const _hoisted_26 = { class: "font-red fw-semibold" }
const _hoisted_27 = {
  class: "progress",
  role: "progressbar",
  "aria-valuenow": "42",
  "aria-valuemin": "0",
  "aria-valuemax": "100"
}
const _hoisted_28 = { class: "col-xxl-3 col-sm-6 card-custom-mobile row-bottom-custom-mobile" }
const _hoisted_29 = { class: "card mb-none mb-sm-none mb-md-25 md-lg-25 md-xl-25 md-xxl-25 border-0 radius-7 bg-white stats-item" }
const _hoisted_30 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing heigth-cards-recordings" }
const _hoisted_31 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative text-info rounded-1 text-center icon-custom-mobile" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-idea" })
], -1))
const _hoisted_33 = { class: "title text-end custom-title-mobile" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-dark-emphasis mb-5 custom-size-title-mobile" }, " TEMPO TOTAL ", -1))
const _hoisted_35 = { class: "d-flex align-items-center justify-content-end result-custom-mobile" }
const _hoisted_36 = { class: "fw-black mb-0 me-none me-sm-none me-lg-10 me-xl-10 me-xxl-10" }
const _hoisted_37 = { class: "col-xxl-3 col-sm-6 card-custom-mobile row-bottom-custom-mobile" }
const _hoisted_38 = { class: "card mb-3 border-0 radius-7 bg-white stats-item" }
const _hoisted_39 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing heigth-cards-recordings" }
const _hoisted_40 = { class: "d-flex align-items-center justify-content-between" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon position-relative text-danger rounded-1 text-center icon-custom-mobile" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-user-3" })
], -1))
const _hoisted_42 = { class: "title text-end custom-title-mobile" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "d-block fw-bold text-dark-emphasis mb-5 custom-size-title-mobile" }, " TAMANHO TOTAL ", -1))
const _hoisted_44 = { class: "d-flex align-items-center justify-content-end result-custom-mobile" }
const _hoisted_45 = { class: "fw-black mb-0 me-none me-sm-none me-lg-10 me-xl-10 me-xxl-10" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-15 mt-md-20 users-list d-flex align-items-center icon-custom-mobile" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-circle bg-primary-emphasis text-center d-flex align-items-center justify-content-center text-white fs-16 space-between-options-files-card-recording" }, " wav "),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-circle bg-info text-center d-flex align-items-center justify-content-center text-white fs-16 space-between-options-files-card-recording" }, " gsm "),
  /*#__PURE__*/_createElementVNode("div", { class: "rounded-circle bg-primary text-center d-flex align-items-center justify-content-center text-white fs-16 space-between-options-files-card-recording" }, " mp3 ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, _toDisplayString(_ctx.getRecordingsCards.total_success), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.getRecordingsCards.percentage_success) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "progress-bar bg-success",
              style: _normalizeStyle({ width: _ctx.getRecordingsCards.percentage_success + '%' })
            }, null, 4)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _hoisted_21,
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("h3", _hoisted_23, _toDisplayString(_ctx.getRecordingsCards.total_error), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _hoisted_25,
            _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.getRecordingsCards.percentage_error) + "%", 1)
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", {
              class: "progress-bar bg-red",
              style: _normalizeStyle({ width: _ctx.getRecordingsCards.percentage_error + '%' })
            }, null, 4)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("h3", _hoisted_36, _toDisplayString(_ctx.convertTime(_ctx.getRecordingsCards.total_time)), 1)
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_37, [
      _createElementVNode("div", _hoisted_38, [
        _createElementVNode("div", _hoisted_39, [
          _createElementVNode("div", _hoisted_40, [
            _hoisted_41,
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createElementVNode("div", _hoisted_44, [
                _createElementVNode("h3", _hoisted_45, _toDisplayString((_ctx.getRecordingsCards.total_size / (1024 * 1024)).toFixed(2) + " MB"), 1)
              ])
            ])
          ]),
          _hoisted_46
        ])
      ])
    ])
  ]))
}